import { CONSTANTS } from '@/types/enum/constants'

const getIsUserAdminStoreBagBackOffice = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles.find(value => CONSTANTS.ROLE_DYNAMIC_ROUTE_PLV_ADMIN == value) || false

export default getIsUserAdminStoreBagBackOffice
